export const styles = {
  form: {
    field: {
      panel: 'mb3',
      label: 'f7 db mb2 ttu b lh-title black-80',
      tooltip: 'f6 black-60 db mb2',
      input: 'input-reset bn black bg-near-white hover-bg-black-10 pa2 pa3-ns br3 mb2 db w-100',
    },
  },
  header: {
    panel: 'tc ma0 mb5',
    title: 'tc f1-ns lh-title b ma0 black',
    subtitle: 'f5 f4-ns lh-copy black-70 ma0 mb4 mt3 mw7 ml-auto mr-auto',
  },
  section: {
    wrapper: 'mb3',
    title: 'f4 ma0 mt3 bb bw b--black-10 pb2',
    panel: 'pv2 pv3-ns',
  },
};

export default styles;
